/**
 * Heat Map Layer
 * @param map  an instance of BingMaps.Map
 * @param layer  the Bing maps layer to render shapes to
 */
define(['jquery', 'c21/track'], function ($, track) {
   "use strict";

   return function (map, layer) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_layer = layer,
         m_aShapes = [],

         //m_map = map,

         /**
          * Draw a polygon to the map with the specified coordinates and color
          * @param aLocation
          * @param polygonColor
          */
         drawPolygon = function (aLocation, polygonColor, label, scale) {
            var poly = new BingMaps.Polygon(aLocation, {
               fillColor: polygonColor,
               strokeColor: new BingMaps.Color(200 / 255, 255, 255, 255),
               strokeThickness: 0
            }),
               jTooltip = $(".overlayToolTip");

            // Add the shape to the map
            m_layer.add(poly);
            m_aShapes.push(poly);

            BingMaps.Events.addHandler(poly, 'mouseover', function (e) {
               var rightPos = 140 - scale * 84;
               jTooltip.find("#overlayToolTipText").html(label);

               //GA Tag: Heat Map Hover State
               if (label !== null && label !== "") {
                  var location = label.substr(0, label.indexOf('<br>'));
                  if (location !== null && location !== "") {
                     track.doEvent('Hybrid Mapping', 'Heat Map', 'Hover over ' + location + ' on map');
                  }
               }

               var fillColor = BingMaps.Color.clone(polygonColor);
               fillColor.a = 80 / 255;

               rightPos -= (parseInt(jTooltip.css("width"), 10) / 2);
               e.target.setOptions({
                  strokeThickness: 2,
                  strokeColor: new BingMaps.Color(1, 50, 50, 50),
                  fillColor: fillColor
               });
               clearTimeout(window.heatMapTimeout);

               var bottomPos = '202px';
               if (!$("#mapToolsToggleButton").hasClass("selected")) {
                  bottomPos = '7px';
               }

               if (!jTooltip.hasClass("shown")) {
                  jTooltip.addClass("shown").show().css({
                     right: rightPos
                  }).animate({
                     opacity: 1
                  }, 1000);
               } else {
                  jTooltip.css({
                     display: 'block',
                     opacity: 1,
                     right: rightPos,
                     bottom: bottomPos
                  });
               }
            });
            BingMaps.Events.addHandler(poly, 'mouseout', function (e) {
               var color = e.target.getFillColor();
               color.a = 130 / 255;
               e.target.setOptions({
                  strokeThickness: 0,
                  strokeColor: new BingMaps.Color(50 / 255, 50, 50, 50),
                  fillColor: color
               });
               clearTimeout(window.heatMapTimeout);
               window.heatMapTimeout = setTimeout(function () {
                  jTooltip.removeClass("shown").animate({
                     opacity: 0
                  }, function () {
                     $(this).hide();
                  });
               }, 2000);
            });
         },

         /** 
          * Get a color between two other colors
          * @param startColor  an array [r, g, b]
          * @param endColor    an array [r, g, b]
          * @param position    a decimal from 0 - 1
          * @param midColor
          * @return an object with rgb values
          */
         getColorAtPosition = function (startColor, endColor, position, midColor) {
            var fx = {
               start: startColor,
               end: endColor,
               pos: position,
               mid: midColor
            };

            if (midColor) {
               if (position < 0.5) {
                  return {
                     r: Math.max(Math.min(parseInt((2 * fx.pos * (fx.mid[0] - fx.start[0])) + fx.start[0], 10), 255), 0),
                     g: Math.max(Math.min(parseInt((2 * fx.pos * (fx.mid[1] - fx.start[1])) + fx.start[1], 10), 255), 0),
                     b: Math.max(Math.min(parseInt((2 * fx.pos * (fx.mid[2] - fx.start[2])) + fx.start[2], 10), 255), 0)
                  };
               }

               fx.pos -= 0.5;
               return {
                  r: Math.max(Math.min(parseInt((2 * fx.pos * (fx.end[0] - fx.mid[0])) + fx.mid[0], 10), 255), 0),
                  g: Math.max(Math.min(parseInt((2 * fx.pos * (fx.end[1] - fx.mid[1])) + fx.mid[1], 10), 255), 0),
                  b: Math.max(Math.min(parseInt((2 * fx.pos * (fx.end[2] - fx.mid[2])) + fx.mid[2], 10), 255), 0)
               };
            }

            return {
               r: Math.max(Math.min(parseInt((fx.pos * (fx.end[0] - fx.start[0])) + fx.start[0], 10), 255), 0),
               g: Math.max(Math.min(parseInt((fx.pos * (fx.end[1] - fx.start[1])) + fx.start[1], 10), 255), 0),
               b: Math.max(Math.min(parseInt((fx.pos * (fx.end[2] - fx.start[2])) + fx.start[2], 10), 255), 0)
            };
         },

         /**
          * Get the color of the polygon by the heat number
          * @param iHeat  a number from 1-10
          * @return BingMaps.Color
          */
         getColorHeat = function (iHeat, iScaleStart, iScaleEnd) {
            var iScaleLength = iScaleEnd - iScaleStart,
               iHeatPercent = (iHeat - iScaleStart) / iScaleLength,

               startColor = [0, 255, 255],
               endColor = [255, 0, 0],
               midColor = [255, 255, 0],
               color = getColorAtPosition(startColor, endColor, iHeatPercent, midColor);

            return new BingMaps.Color(130, color.r, color.g, color.b);
         },

         initialize = function () {};

      initialize();

      self.addMapLocation = function (aLocation, iHeat, iScaleStart, iScaleEnd, label) {
         var color = getColorHeat(iHeat, iScaleStart, iScaleEnd),
            // 25 20 120    100   5  
            scale = (iHeat <= iScaleStart ? 0 : (iHeat >= iScaleEnd ? 1 : ((iHeat - iScaleStart) / (iScaleEnd - iScaleStart))));
         drawPolygon(aLocation, color, label, scale);
      };

      self.clearHeatMap = function () {
         $(".heatMapLegend").hide();
         $.each(m_aShapes, function (i, shape) {
            m_layer.remove(shape);
         });
      };
   };
});
